import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  class: "d-flex justify-content-end",
  "data-kt-subscription-table-toolbar": "base"
}
const _hoisted_8 = { class: "svg-icon svg-icon-2" }
const _hoisted_9 = { class: "card-body p-9" }
const _hoisted_10 = { class: "mb-10" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "d-flex flex-wrap py-5" }
const _hoisted_13 = { class: "flex-equal me-5" }
const _hoisted_14 = { class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_15 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_16 = { class: "text-gray-800 min-w-200px" }
const _hoisted_17 = { class: "text-gray-400" }
const _hoisted_18 = { class: "text-gray-800" }
const _hoisted_19 = { class: "text-gray-400" }
const _hoisted_20 = { class: "text-gray-800" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "text-gray-400" }
const _hoisted_23 = { class: "text-gray-800" }
const _hoisted_24 = { class: "flex-equal" }
const _hoisted_25 = { class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_26 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_27 = { class: "text-gray-800 min-w-200px" }
const _hoisted_28 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_29 = { class: "text-gray-800 min-w-200px" }
const _hoisted_30 = { class: "text-gray-400" }
const _hoisted_31 = { class: "text-gray-800" }
const _hoisted_32 = { class: "badge badge-light text-uppercase px-0" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_35 = { class: "text-gray-800 min-w-200px" }
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = { class: "mb-4" }
const _hoisted_38 = { class: "d-flex flex-wrap py-5" }
const _hoisted_39 = { class: "flex-equal me-5" }
const _hoisted_40 = { class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_41 = { class: "text-gray-400" }
const _hoisted_42 = { class: "text-gray-800" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "text-gray-400" }
const _hoisted_45 = { class: "text-gray-800" }
const _hoisted_46 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_47 = { class: "text-gray-800 min-w-200px" }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_50 = { class: "text-gray-800 min-w-200px" }
const _hoisted_51 = { class: "flex-equal" }
const _hoisted_52 = { class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_53 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_54 = { class: "text-gray-800 min-w-200px" }
const _hoisted_55 = { class: "text-gray-400" }
const _hoisted_56 = { class: "text-gray-800" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "text-gray-400" }
const _hoisted_59 = { class: "text-gray-800" }
const _hoisted_60 = { class: "mt-10" }
const _hoisted_61 = { class: "mb-4" }
const _hoisted_62 = { class: "d-flex flex-wrap py-5" }
const _hoisted_63 = { class: "flex-equal me-5" }
const _hoisted_64 = {
  key: 0,
  class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0"
}
const _hoisted_65 = { class: "text-gray-400" }
const _hoisted_66 = { class: "text-gray-800" }
const _hoisted_67 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_68 = { class: "text-gray-800 min-w-200px" }
const _hoisted_69 = { class: "flex-equal" }
const _hoisted_70 = {
  key: 0,
  class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0"
}
const _hoisted_71 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_72 = { class: "text-gray-800 min-w-200px" }
const _hoisted_73 = {
  key: 0,
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_74 = { class: "card-header" }
const _hoisted_75 = { class: "card-title" }
const _hoisted_76 = { class: "fw-bolder" }
const _hoisted_77 = { class: "mb-10" }
const _hoisted_78 = ["data-src", "data-sub-html"]
const _hoisted_79 = ["src"]
const _hoisted_80 = {
  key: 1,
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_81 = { class: "card-header" }
const _hoisted_82 = { class: "card-title" }
const _hoisted_83 = { class: "fw-bolder" }
const _hoisted_84 = { class: "mb-10" }
const _hoisted_85 = ["data-video", "data-sub-html"]
const _hoisted_86 = ["src"]
const _hoisted_87 = {
  key: 2,
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_88 = { class: "card-header" }
const _hoisted_89 = { class: "card-title" }
const _hoisted_90 = { class: "fw-bolder" }
const _hoisted_91 = { class: "mb-10" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-60px symbol-2by3 me-4" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "symbol-label contain-symbol",
    style: {"background-image":"url('/media/svg/files/pdf.svg'"}
  })
], -1)
const _hoisted_93 = { class: "d-flex flex-row-fluid flex-wrap align-items-center" }
const _hoisted_94 = { class: "flex-grow-1 me-2" }
const _hoisted_95 = ["onClick"]
const _hoisted_96 = { class: "text-muted fw-bold d-block pt-1" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = { class: "svg-icon-2 svg-icon-primary" }
const _hoisted_99 = {
  key: 3,
  class: "card mb-5 mb-xl-10 actions-card"
}
const _hoisted_100 = { class: "card-header border-0 actions-header" }
const _hoisted_101 = { class: "card-title" }
const _hoisted_102 = { class: "fw-bolder" }
const _hoisted_103 = { class: "actions-section" }
const _hoisted_104 = { class: "section-header" }
const _hoisted_105 = { class: "fw-bold mb-3" }
const _hoisted_106 = { class: "card-body p-6" }
const _hoisted_107 = { class: "row mb-6" }
const _hoisted_108 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_109 = { class: "col-lg-8 fv-row" }
const _hoisted_110 = { value: "1" }
const _hoisted_111 = { value: "0" }
const _hoisted_112 = { value: "2" }
const _hoisted_113 = { class: "fv-plugins-message-container" }
const _hoisted_114 = { class: "fv-help-block" }
const _hoisted_115 = { class: "row mb-6" }
const _hoisted_116 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_117 = { class: "col-lg-8 fv-row" }
const _hoisted_118 = { class: "row mb-6" }
const _hoisted_119 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_120 = { class: "col-lg-8 fv-row" }
const _hoisted_121 = { class: "fv-plugins-message-container" }
const _hoisted_122 = { class: "fv-help-block" }
const _hoisted_123 = { class: "card-footer d-flex justify-content-end py-4 px-6 bg-light-dark" }
const _hoisted_124 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_125 = { class: "indicator-label" }
const _hoisted_126 = { class: "indicator-progress" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, null, -1)
const _hoisted_129 = { class: "actions-section" }
const _hoisted_130 = { class: "section-header" }
const _hoisted_131 = { class: "fw-bold mb-3" }
const _hoisted_132 = { class: "card-body p-6" }
const _hoisted_133 = { class: "row mb-6" }
const _hoisted_134 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_135 = { class: "col-lg-8 fv-row" }
const _hoisted_136 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_137 = { class: "form-check-label ms-2" }
const _hoisted_138 = { class: "fv-plugins-message-container" }
const _hoisted_139 = { class: "fv-help-block" }
const _hoisted_140 = { class: "row mb-6" }
const _hoisted_141 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_142 = { class: "col-lg-8 fv-row" }
const _hoisted_143 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_144 = { class: "form-check-label ms-2" }
const _hoisted_145 = { class: "fv-plugins-message-container" }
const _hoisted_146 = { class: "fv-help-block" }
const _hoisted_147 = { class: "card-footer d-flex justify-content-end py-4 px-6 bg-light-dark" }
const _hoisted_148 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit2",
  ref: "submitButtonQuality",
  class: "btn btn-primary"
}
const _hoisted_149 = { class: "indicator-label" }
const _hoisted_150 = { class: "indicator-progress" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_lightgallery = _resolveComponent("lightgallery")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'ads'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.translate('adsDetails')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/manage/ads/ads-listing",
                  class: "btn btn-light me-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate('backToList')), 1)
                  ]),
                  _: 1
                }),
                (_ctx.can('update', 'ads'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/manage/ads/ads-updating/${_ctx.ad.id}`,
                      class: "btn btn-primary me-3"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_8, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.translate('editAd')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.translate('basicInfo')) + ":", 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("table", _hoisted_14, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.translate('publishName')) + ": ", 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.ad.publishName), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.translate('publishMobile')) + ": ", 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.ad.publishMobile), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.translate('activeStatus')) + ": ", 1),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`badge ${_ctx.getBadgeClass(
                        _ctx.ad.statusId
                      )} text-uppercase px-0`)
                        }, _toDisplayString(_ctx.ad.statusTitle), 3)
                      ])
                    ]),
                    (_ctx.ad.additionalInfo)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                          _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.translate('additionalInfo')) + ": ", 1),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.ad.additionalInfo), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("table", _hoisted_25, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.translate('adsType')) + ": ", 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.ad.adsTypes), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.translate('publishedAt')) + ": ", 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.ad.publishedAt), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.translate('isPaid')) + ":", 1),
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.translate(_ctx.ad.isPaid ? 'yes' : 'no')), 1)
                      ])
                    ]),
                    (_ctx.ad.adsPackagesTitle)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                          _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.translate('adsPackagesTitle')) + ": ", 1),
                          _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.ad.adsPackagesTitle), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("h5", _hoisted_37, _toDisplayString(_ctx.translate('propertyInfo')) + ":", 1),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("table", _hoisted_40, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.translate('appraisalPropertyTypes')) + ": ", 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.ad.propertyTypes), 1)
                    ]),
                    (_ctx.ad.propertyCategory)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                          _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.translate('propertyCategory')) + ": ", 1),
                          _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.ad.propertyCategory), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.translate('areaName')) + ": ", 1),
                      _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.ad.areaName), 1)
                    ]),
                    (_ctx.ad.numRooms)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                          _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.translate('numRooms')) + ": ", 1),
                          _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.ad.numRooms), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("table", _hoisted_52, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.translate('price')) + ": ", 1),
                      _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.ad.priceTitle ? _ctx.ad.priceTitle : _ctx.ad.price), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.translate('size')) + ":", 1),
                      _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.ad.size), 1)
                    ]),
                    (_ctx.ad.numBathrooms)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                          _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.translate('numBathrooms')) + ": ", 1),
                          _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.ad.numBathrooms), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("h5", _hoisted_61, _toDisplayString(_ctx.translate('UserInfo')) + ":", 1),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  (_ctx.ad.members)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_64, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.translate('name')) + ":", 1),
                          _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.ad.members.name), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.translate('email')) + ": ", 1),
                          _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.ad.members.email), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_69, [
                  (_ctx.ad.members)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_70, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.translate('phone')) + ": ", 1),
                          _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.ad.members.phone), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        (_ctx.ad.thumbnail && _ctx.ad.thumbnail.image && _ctx.ad.thumbnail.image.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("h2", _hoisted_76, _toDisplayString(_ctx.translate('attachmentImages')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createVNode(_component_lightgallery, {
                  settings: {
            zoom: false,
            download: true,
            speed: 500,
            plugins: _ctx.plugins,
          },
                  onInit: _ctx.onInit,
                  onBeforeSlide: _ctx.onBeforeSlide
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ad.thumbnail.image, (item, index) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: `image-${index}`,
                        class: "gallery-item",
                        "data-src": item.name,
                        "data-sub-html": `<h4>Ads Images - <a href='https://alhsba.com/' >alhisba.com </a></h4> <p> - images #${
              index + 1
            } - </a></p>`
                      }, [
                        _createElementVNode("img", {
                          class: "img-responsive fixed-size border border-5 rounded",
                          src: item.name
                        }, null, 8, _hoisted_79)
                      ], 8, _hoisted_78))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["settings", "onInit", "onBeforeSlide"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.ad.thumbnail && _ctx.ad.thumbnail.video && _ctx.ad.thumbnail.video.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("h2", _hoisted_83, _toDisplayString(_ctx.translate('attachmentVideos')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_component_lightgallery, {
                  settings: {
            zoom: false,
            download: false,
            speed: 500,
            plugins: _ctx.plugins,
          },
                  onInit: _ctx.onInit,
                  onBeforeSlide: _ctx.onBeforeSlide
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      class: "gallery-item",
                      "data-video": `{"source": [{"src":"${_ctx.ad.thumbnail.video[0].name}", "type":"video/mp4"}], "attributes": {"preload": false, "controls": true}}`,
                      "data-poster": "",
                      "data-sub-html": `<h4>Ads video - <a href='https://alhisba.com/' >alhisba.com </a></h4> <p> - video- </a></p>`
                    }, [
                      _createElementVNode("img", {
                        class: "img-responsive fixed-size border border-5 rounded",
                        src: _ctx.ad.thumbnail.video[0].thumbnail
                      }, null, 8, _hoisted_86)
                    ], 8, _hoisted_85)
                  ]),
                  _: 1
                }, 8, ["settings", "onInit", "onBeforeSlide"])
              ])
            ]))
          : _createCommentVNode("", true),
        (
        _ctx.ad.thumbnail &&
        _ctx.ad.thumbnail.document &&
        _ctx.ad.thumbnail.document.length > 0
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("h2", _hoisted_90, _toDisplayString(_ctx.translate('docAttachment')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_91, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ad.thumbnail.document, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `propertyImage-${index}`,
                    class: _normalizeClass([{
              'mb-7': _ctx.ad.thumbnail.document.length - 1 !== index,
            }, "d-flex align-items-sm-center"])
                  }, [
                    _hoisted_92,
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-gray-800 fw-bolder text-hover-primary fs-6 text-capitalize",
                          onClick: _withModifiers(($event: any) => (_ctx.downloadAttachment(item)), ["prevent"])
                        }, _toDisplayString(_ctx.getAttachmentName(item, index)), 9, _hoisted_95),
                        _createElementVNode("span", _hoisted_96, _toDisplayString(item.mime), 1)
                      ]),
                      _createElementVNode("a", {
                        href: "#",
                        class: "btn btn-icon btn-light btn-sm border-0 me-3",
                        onClick: _withModifiers(($event: any) => (_ctx.downloadAttachment(item)), ["prevent"])
                      }, [
                        _createElementVNode("span", _hoisted_98, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr065.svg" })
                        ])
                      ], 8, _hoisted_97)
                    ])
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.can('read', 'ads'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("h2", _hoisted_102, _toDisplayString(_ctx.translate('actions')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("h4", _hoisted_105, _toDisplayString(_ctx.translate('changeAdsRequestStatus')), 1)
                ]),
                _createVNode(_component_Form, {
                  class: "form",
                  onSubmit: _ctx.onSubmitUpdate,
                  "validation-schema": _ctx.adsSchema
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.translate('activeStatus')), 1),
                        _createElementVNode("div", _hoisted_109, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: "isApproved",
                            class: "form-select form-select-solid form-select-lg",
                            modelValue: _ctx.selectedStatus,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStatus) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_110, _toDisplayString(_ctx.translate('approved')), 1),
                              _createElementVNode("option", _hoisted_111, _toDisplayString(_ctx.translate('rejected')), 1),
                              _createElementVNode("option", _hoisted_112, _toDisplayString(_ctx.translate('inactive')), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("div", _hoisted_114, [
                              _createVNode(_component_ErrorMessage, { name: "isApproved" })
                            ])
                          ])
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_115, [
                        _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.translate('rejection')), 1),
                        _createElementVNode("div", _hoisted_117, [
                          _createVNode(_component_Multiselect, {
                            modelValue: _ctx.rejection,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rejection) = $event)),
                            requierd: false,
                            label: "rejectReason",
                            trackBy: "rejectReason",
                            searchable: true,
                            canDeselect: false,
                            options: _ctx.rejectReasons,
                            placeholder: _ctx.translate('selectRejectReasons'),
                            valueProp: "rejectReason",
                            noResultsText: _ctx.translate('noResultsFound'),
                            onInput: _ctx.updaterejectionNote
                          }, null, 8, ["modelValue", "options", "placeholder", "noResultsText", "onInput"])
                        ])
                      ], 512), [
                        [_vShow, _ctx.selectedStatus == 0]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_118, [
                        _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.translate('rejectionNote')), 1),
                        _createElementVNode("div", _hoisted_120, [
                          _createVNode(_component_Field, {
                            as: "textarea",
                            name: "rejectionNote",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('rejectionNote'),
                            modelValue: _ctx.rejectionNote,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rejectionNote) = $event))
                          }, null, 8, ["placeholder", "modelValue"]),
                          _createElementVNode("div", _hoisted_121, [
                            _createElementVNode("div", _hoisted_122, [
                              _createVNode(_component_ErrorMessage, { name: "rejectionNote" })
                            ])
                          ])
                        ])
                      ], 512), [
                        [_vShow, _ctx.selectedStatus == 0]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_123, [
                      _createElementVNode("button", {
                        type: "reset",
                        class: "btn btn-light me-2",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                      }, _toDisplayString(_ctx.translate('discard')), 1),
                      (_ctx.can('update', 'ads'))
                        ? (_openBlock(), _createElementBlock("button", _hoisted_124, [
                            _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.translate('saveChanges')), 1),
                            _createElementVNode("span", _hoisted_126, [
                              _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                              _hoisted_127
                            ])
                          ], 512))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit", "validation-schema"])
              ]),
              _hoisted_128,
              _createElementVNode("div", _hoisted_129, [
                _createElementVNode("div", _hoisted_130, [
                  _createElementVNode("h4", _hoisted_131, _toDisplayString(_ctx.translate('isHighQuality')), 1)
                ]),
                _createVNode(_component_Form, {
                  class: "form",
                  "initial-values": {
            isHighQuality: !!_ctx.ad.isHighQuality,
            isSpecial: !!_ctx.ad.isSpecial,
          },
                  onSubmit: _ctx.onSubmitUpdateQuality
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_132, [
                      _createElementVNode("div", _hoisted_133, [
                        _createElementVNode("label", _hoisted_134, _toDisplayString(_ctx.translate('displayOnHomepage')), 1),
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("div", _hoisted_136, [
                            _createVNode(_component_Field, {
                              type: "checkbox",
                              name: "isHighQuality",
                              class: "form-check-input",
                              value: true,
                              "unchecked-value": false,
                              modelValue: _ctx.ad.isHighQuality,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ad.isHighQuality) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.translate('')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_138, [
                            _createElementVNode("div", _hoisted_139, [
                              _createVNode(_component_ErrorMessage, { name: "isHighQuality" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_140, [
                        _createElementVNode("label", _hoisted_141, _toDisplayString(_ctx.translate('upgradeToFeaturedAd')), 1),
                        _createElementVNode("div", _hoisted_142, [
                          _createElementVNode("div", _hoisted_143, [
                            _createVNode(_component_Field, {
                              type: "checkbox",
                              name: "isSpecial",
                              class: "form-check-input",
                              value: true,
                              "unchecked-value": false,
                              modelValue: _ctx.ad.isSpecial,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ad.isSpecial) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.translate('')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_145, [
                            _createElementVNode("div", _hoisted_146, [
                              _createVNode(_component_ErrorMessage, { name: "isSpecial" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_147, [
                      _createElementVNode("button", {
                        type: "reset",
                        class: "btn btn-light me-2",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                      }, _toDisplayString(_ctx.translate('discard')), 1),
                      (_ctx.can('update', 'ads'))
                        ? (_openBlock(), _createElementBlock("button", _hoisted_148, [
                            _createElementVNode("span", _hoisted_149, _toDisplayString(_ctx.translate('saveChanges')), 1),
                            _createElementVNode("span", _hoisted_150, [
                              _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                              _hoisted_151
                            ])
                          ], 512))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["initial-values", "onSubmit"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}